/**
 * External dependencies
 */
import { registerPlugin } from '@wordpress/plugins';

const render = () => { };

registerPlugin('addify-cp-cart-block', {
    render,
    scope: 'woocommerce-cart',
});

